import { css } from '@emotion/react';
import * as S from '~/components/Chat/Chat01/TextBox/TextBox.styled';
import { Member } from '~/types';
import MentionList from './MentionList';

interface GroupChatTextProps {
  members: Member[];
  inpRef: React.RefObject<HTMLDivElement>;
  mentionListRef: React.RefObject<HTMLUListElement>;
  isOpen: boolean;
  onSelect: (e: any, member: Member) => void;
  selectedIndex: number;
  bottomOffset: number;
}

export default function GroupChatText({
  members,
  inpRef,
  mentionListRef,
  isOpen,
  onSelect,
  selectedIndex,
  bottomOffset,
}: GroupChatTextProps) {
  return (
    <>
      <S.TextBox
        css={css`
          display: flex;
          position: relative;
          align-items: center;
          justify-content: center;
        `}
      >
        <S.Text contentEditable ref={inpRef} className='inp' />
      </S.TextBox>
      <MentionList
        members={members}
        isOpen={isOpen}
        mentionListRef={mentionListRef}
        onSelect={onSelect}
        selectedIndex={selectedIndex}
        bottomOffset={bottomOffset}
      />
    </>
  );
}
